import React from 'react';
import SEO from '../components/SEO';
import './PrivacyPage.css';

function PrivacyPage() {
  return (
  <>
    {/* SEO Meta Tags */}
    <SEO
      title="गोपनीयता नीति - RR NEWS TV FASTEST UPDATE"
      description="RR NEWS TV FASTEST UPDATE की गोपनीयता नीति। जानें हम आपकी जानकारी कैसे सुरक्षित रखते हैं।"
      keywords="गोपनीयता, privacy policy, डेटा सुरक्षा, RR NEWS TV FASTEST UPDATE"
      url="/privacy"
      type="website"
    />
    
  <main id="content-start" className="privacy-page container">
      <header className="privacy-hero reveal">
        <h1 className="privacy-title">RR NEWS TV FASTEST UPDATE — गोपनीयता नीति</h1>
        <p className="privacy-sub">(Privacy Policy – Short Version)</p>
      </header>
      <section className="privacy-section card reveal">
        <h2 className="section-heading">परिचय</h2>
        <p>
          RR News TV (RR News Fastest Update) ('हम', 'हमारा' या 'पोर्टल') आपकी गोपनीयता (Privacy) का सम्मान और सुरक्षा करने के लिए प्रतिबद्ध है। यह गोपनीयता नीति यह बताती है कि जब आप हमारी वेबसाइट, ई-पेपर या सोशल मीडिया प्लेटफ़ॉर्म पर आते हैं, तो हम आपकी कौन सी जानकारी एकत्र करते हैं और उसका उपयोग कैसे करते हैं।
        </p>
      </section>

      <section className="privacy-section card reveal">
        <h2 className="section-heading">हम कौन सी जानकारी एकत्र करते हैं?</h2>
        <p>
          व्यक्तिगत जानकारी: जब आप हमारे न्यूज़लेटर की सदस्यता लेते हैं, ई-पेपर डाउनलोड करते हैं, या हमसे संपर्क फॉर्म के माध्यम से जुड़ते हैं, तो हम आपका नाम, ईमेल आईडी और फोन नंबर जैसी जानकारी प्राप्त कर सकते हैं।
        </p>
        <p>
          स्वचालित जानकारी (Cookies): वेबसाइट के उपयोग को बेहतर बनाने के लिए हम कुकीज़ (Cookies) और तकनीकी डेटा (जैसे ब्राउज़र का प्रकार, आईपी एड्रेस और विजिट का समय) का उपयोग कर सकते हैं।
        </p>
      </section>

      <section className="privacy-section card reveal">
        <h2 className="section-heading">जानकारी का उपयोग कैसे किया जाता है?</h2>
        {/* <p>संग्रहित जानकारी का उपयोग निम्न कार्यों के लिए किया जाता है:</p> */}
        <ul>
          <li>आपको सबसे तेज और सटीक समाचार, अपडेट्स और ई-पेपर समय पर भेजने के लिए।</li>
          <li>पाठकों और दर्शकों की प्रतिक्रियाओं के आधार पर हमारी वेबसाइट की सेवाओं में सुधार करने के लिए।</li>
          <li>किसी भी कानूनी दायित्व का पालन करने या धोखाधड़ी से बचने के लिए।</li>
          <li>उपयोगकर्ता द्वारा भेजी गई खबर/फोटो को सत्यापन के बाद प्रकाशित करना (अनुमति के साथ)</li>
        </ul>
        {/* <p>हम किसी भी जानकारी का उपयोग व्यावसायिक बिक्री या अवैध गतिविधि के लिए नहीं करते।</p> */}
      </section>

      <section className="privacy-section card reveal">
        <h2 className="section-heading">डेटा सुरक्षा और तृतीय पक्ष</h2>
        <p>सुरक्षित डेटा: हम आपकी व्यक्तिगत जानकारी (जैसे ईमेल या फोन नंबर) को पूरी तरह सुरक्षित रखते हैं।
बिना अनुमति साझा नहीं करना: हम आपकी कोई भी व्यक्तिगत जानकारी किसी भी तीसरे पक्ष (Third Party) को बेचते, व्यापार करते या बिना अनुमति के साझा नहीं करते हैं, सिवाय इसके कि जब कानूनन ऐसा करना आवश्यक हो।</p>
      </section>

      <section className="privacy-section card reveal">
        <h2 className="section-heading">तृतीय पक्ष लिंक</h2>
        <p>हमारी वेबसाइट पर अन्य वेबसाइटों या सोशल मीडिया प्लेटफॉर्म के लिंक हो सकते हैं। उन बाहरी साइटों की अपनी गोपनीयता नीतियां होती हैं, जिनके लिए RR News TV जिम्मेदार नहीं है।</p>
      </section>

      <section className="privacy-section card reveal">
        <h2 className="section-heading">नीति में बदलाव</h2>
        <p>हम अपनी गोपनीयता नीति को समय-समय पर अपडेट कर सकते हैं। नीति में किसी भी बदलाव की सूचना इसी पेज पर दी जाएगी।</p>
      </section>

      {/* <section className="privacy-section card reveal">
        <h2 className="section-heading">6. उपयोगकर्ता अधिकार</h2>
        <p>उपयोगकर्ता अपनी व्यक्तिगत जानकारी को देखने, सुधारने या हटाने का अनुरोध कर सकते हैं। वे किसी भी समय ई-पेपर या नोटिफिकेशन सेवाएँ बंद करने का विकल्प रख सकते हैं।</p>
      </section> */}

      <section className="privacy-section card reveal">
        <h2 className="section-heading">7. नीति में परिवर्तन</h2>
        <p>हम समय-समय पर गोपनीयता नीति को अपडेट कर सकते हैं। उपयोगकर्ताओं को सुझाव दिया जाता है कि वे इस पेज को समय-समय पर पुनः देखें।</p>

        <div className="privacy-ctas">
          <a className="btn primary" href="mailto:support@moradabadujala.in">ईमेल: rrofficial893@gmail.com</a>
          <a className="btn" href="tel:+91-5921354286">फोन/व्हाट्सएप: +91-8979916908</a>
        </div>
      </section>

      <footer className="privacy-footer reveal">
        <p>यदि आपके पास गोपनीयता से संबंधित कोई प्रश्न हैं तो बेझिझक हमसे संपर्क करें।</p>
      </footer>
    </main>
  </>
  );
}

export default PrivacyPage;


